import { writable } from 'svelte/store';
export const title = writable('');
export const subTitle = writable('');
export const titleTextSize = writable(64);
export const subTitleTextSize = writable(36);
export const titleTextColor = writable('#ff3e00');
export const subTitleTextColor = writable('#ff3e00');
export const bgColor = writable('#ffffff');
export const align = writable('center');
export const justify = writable('center');
export let src = writable('');
export const url = writable('');
export const filename = writable('');
